import { BaseService } from '@services/BaseService';
import { OptionsViewModel, PageViewModel } from '@models/common.models';
import { CoverageOption } from '@models/CoverageOption';
import { PriceAdjustmentViewModel, GetPriceAdjustmentMetadata, ProductCoverageViewModel } from '@models/Product';

class ProductService extends BaseService {
  constructor() {
    super('products');
  }

  getProductChannels() {
    return this.fetch<OptionsViewModel[]>('channels', {
      method: 'GET'
    });
  }

  getProductGroups(zipCode: string, propertySaleType: number, propertyType: number) {
    return this.fetch<OptionsViewModel[]>(
      `saletype/${propertySaleType}/propertyType/${propertyType}/groups?zipCode=${zipCode}`,
      {
        method: 'GET'
      }
    );
  }

  getProducts(groupId: number, propertyType: number, saleType: number, renewal: boolean) {
    return this.fetch<OptionsViewModel[]>(
      `type/${propertyType}/group/${groupId}/saleType/${saleType}?renewal=${renewal}`,
      {
        method: 'GET'
      }
    );
  }

  getProductOptions() {
    return this.fetch<OptionsViewModel[]>('options', {
      method: 'GET'
    });
  }

  getPriceAdjustments(productId: number, adjustmentMetaData: GetPriceAdjustmentMetadata) {
    const customerIdParam =
      adjustmentMetaData.customerId !== 0 && adjustmentMetaData.customerId ? `${adjustmentMetaData.customerId}` : 0;
    return this.fetch<PriceAdjustmentViewModel[]>(
      `${productId}/customer/${customerIdParam}/priceAdjustments?stateAbbr=${
        adjustmentMetaData.stateAbbreviation
      }&hasPropMgmt=${adjustmentMetaData.hasPropertyManagement}&hasAgent=${adjustmentMetaData.hasAgent}`,
      {
        method: 'GET'
      }
    );
  }

  getCoverageOptions(
    groupId: number,
    productId: number,
    isSellerCoverage: boolean = false,
    selectedCoverageOptions: Array<CoverageOption>
  ): Promise<Array<CoverageOption>> {
    const prefix = '&selectedCoverageIds=';
    const selectedOptionsQuery =
      selectedCoverageOptions.length > 0
        ? `${prefix}${selectedCoverageOptions
            .map(item => {
              return item.id;
            })
            .join(prefix)}`
        : '';
    return this.fetch<CoverageOption[]>(
      `${productId}/coverages?sellerCoverage=${isSellerCoverage}${selectedOptionsQuery}`,
      {
        method: 'GET'
      }
    );
  }

  getProductCoveragePrice(coverageId: number, productId: number): Promise<number> {
    return this.fetch<number>(`${productId}/coverage/${coverageId}/price`, {
      method: 'GET'
    });
  }

  getEmployeeDiscount(customerId: number) {
    return this.fetch<PriceAdjustmentViewModel[]>(`customer/${customerId}/employeeDiscount`, {
      method: 'GET'
    });
  }
  getRenewalOptions = (
    id: number,
    pageNumber?: number,
    pageSize?: number,
    orderBy?: string,
    orderDirection?: string
  ) => {
    const pn: number | undefined = pageNumber ? Math.max(0, pageNumber) : undefined;
    const ps: number | undefined = pageSize ? Math.max(0, pageSize) : undefined;

    return this.fetch<PageViewModel<ProductCoverageViewModel>>('renewals', {
      method: 'POST',
      body: JSON.stringify({
        id: id,
        pageNumber: pn,
        pageSize: ps,
        orderBy: orderBy,
        orderDirection: orderDirection
      })
    });
  };
}

export const productService = new ProductService();



// WEBPACK FOOTER //
// ./src/_services/ProductService.ts